import { useContext, useEffect, useRef, useState } from "react";
import Layouts from "../../Layouts";
import Badge from "../../../Assets/Icons/batch.svg";
import Age from "../../../Assets/Icons/AgeIcon.svg";
import Gender from "../../../Assets/Icons/gentericon.svg";
import Cake from "../../../Assets/Icons/cake.svg";
import Mail from "../../../Assets/Icons/mail.svg";
import Call from "../../../Assets/Icons/call.svg";
import Location from "../../../Assets/Icons/location.svg";
import Height from "../../../Assets/Icons/height.svg";
import Weight from "../../../Assets/Icons/monitor_weight.svg";
import HR from "../../../Assets/Icons/HR.svg";
import Temp from "../../../Assets/Icons/Temp.svg";
import RR from "../../../Assets/Icons/Rr.png";
import BMI from "../../../Assets/Icons/BMI.svg";
import SPO2 from "../../../Assets/Icons/Sp02.svg";
import Bp from "../../../Assets/Icons/Bp.svg";
import Records from "../../../Assets/Icons/records.svg";
import Arrow from "../../../Assets/Icons/Right Arrow.svg";
import User from "../../../Assets/Icons/user vector.svg";
import Share from "../../../Assets/Icons/share.svg";
import notes from "../../../Assets/Icons/notes1.svg";
import medicines from "../../../Assets/Icons/medicine.svg";
import Lab from "../../../Assets/Icons/Lab.svg";
import Treatment from "../../../Assets/Icons/treatment.svg";
import Speciality from "../../../Assets/Icons/speciality.svg";
import RX from "../../../Assets/Icons/rx.svg";
import ReferIcon from "../../../Assets/Icons/refer.svg";
import preview from "../../../Assets/Icons/preview.svg";
import Notes from "./Notes";
import Medicine from "./Medicine";
import LabTest from "./LabTest";
import TreatmentPlan from "./TreatmentPlan";
import SpecialityNotes from "./SpecialityNotes";
import {
  FaArrowUpRightFromSquare,
  FaCircleUser,
  FaPersonRunning,
} from "react-icons/fa6";
import { useHistory, useLocation } from "react-router-dom";
import dayjs from "dayjs";
import {
  DatePicker,
  Flex,
  Input,
  message,
  Modal,
  Segmented,
  Select,
  Spin,
  Tooltip,
} from "antd";
import { APP_ROUTES } from "../../../PageRouting/approutes";
import ConsultationService from "../../../Services/ConsultationService";
import MedicalHistory from "../ConsultationNotes/VitalTabs/MedicalHistory";
import MyVitals from "../ConsultationNotes/VitalTabs/PatientVitals/PatientVitals";
import Reports from "../ConsultationNotes/VitalTabs/Reports";
import MyPresctription from "../ConsultationNotes/VitalTabs/ViewPrescription";
import NoDataFound from "../../../Assets/Icons/NoDataCard2.svg";
import medicalReportsIcon from "../../../Assets/Images/mdreport.png";
import medicalPrescriptionIcon from "../../../Assets/Images/mdpres.png";
import medicalVitalsIcon from "../../../Assets/Images/mdvitals.png";
import PrescriptionDetails from "../ConsultationNotes/VitalTabs/ViewPrescription/PrescriptionDetails";
import medicalHistoryIcon from "../../../Assets/Images/mdhistory.png";
import CommonFunctions from "../../Shared/CommonFunctions";
import PatientService from "../../../Services/PatientService";
import enrollmentServices from "../../../Services/enrollmentServices";
import Referal from "./Referal";
import { CalendarOutlined } from "@ant-design/icons";
import NewVideoConsult from "./NewVideoConsult";
import { FaRunning, FaVideoSlash } from "react-icons/fa";
import VitalService from "../../../Services/VitalService";
import { FaMicrophone, FaMicrophoneSlash } from "react-icons/fa";
import { VoiceCommandContext } from "../VoiceCommand/VoiceContext";
import { IoIosCloseCircle, IoMdMic, IoMdMicOff } from "react-icons/io";
import VoiceCommandController from "../VoiceCommand/VoiceCommandController";
import ConsentService from "../../../Services/ConsentService";
import PatientQueue from "../VCPage/PatientQueue";
import { MdKeyboardDoubleArrowUp } from "react-icons/md";
import Draggable from "react-draggable";
import patientqueue from "../../../Assets/Images/Svg/queue2.svg";
import vitalsWhite from "../../../Assets/Images/Svg/vitalsWhite.svg";
import vitalsBlack from "../../../Assets/Images/Svg/vitalsBlack.svg";
import ecgWhite from "../../../Assets/Images/Svg/ecgWhite.svg";
import ecgBlack from "../../../Assets/Images/Svg/ecgBlack.svg";
import stethWhite from "../../../Assets/Images/Svg/stethWhite.svg";
import stethBlack from "../../../Assets/Images/Svg/stethBlack.svg";
import activityhWhite from "../../../Assets/Images/Svg/activityWhite.svg";
import bluetooth from "../../../Assets/Images/Svg/bluetooth.svg";
import DigitalECG from "./DigitalECG";
import DigitalSteth from "./DigitalSteth";
import RepeatOrder from "./RepeatOrder";
import Activities from "./Activities";
import AudioRecorder from "./AudioRecorder";
import {
  collection,
  deleteDoc,
  doc,
  getDoc,
  onSnapshot,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import { db } from "../../../config/firebase";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedAppt } from "../../../Redux/actions/UserActions";
import ChCoAndAllDetails from "./ChCoAndAllDetails";
import ViewReports from "./ViewReports";
import ShareMedicine from "./ShareMedicine";
import ShareLab from "./ShareLab";
import {
  onLabOrderSend,
  onMedicineOrderSend,
} from "../../utils/consultationOrders";
import PatientDietPlan from "./PatientDietPlan";

function VideoConsult() {
  const location = useLocation();
  let appointmentDetails = location?.state?.selectedPatient;
  const audioRef = useRef(null);
  const [patientVitals, setPatientVitals] = useState([]);
  const [labPrescription, setLabPrescription] = useState([]);
  const [drugPrescription, setDrugPrescription] = useState([]);
  const [patientDiagnosisDetails, setPatientDiagnosisDetails] = useState([]);
  const [patientDetails, setPatientDetails] = useState({});
  const [loading, setLoading] = useState(false);
  const [chiefComplaints, setChiefComplaints] = useState("");
  const [recommentation, setRecommentation] = useState("");
  const [symptoms, setSymptoms] = useState("");
  const [symptomsCode, setSymptomsCode] = useState([]);
  const [editedPatientDetails, setEditPatientDetails] = useState({});
  const [previewData, setPreviewData] = useState(null);
  const history = useHistory();
  const [updatePayload, setUpdatePayload] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [referModal, setReferModal] = useState(false);
  const [hasConsultationId, setHasConsultationId] = useState(false);

  const storedLoginResult = sessionStorage.getItem("login_result");
  const loginResultObject = storedLoginResult
    ? JSON.parse(storedLoginResult)
    : null;

  //share orders
  const [medicineOrders, setMedicineOrders] = useState(false);
  const [labOrders, setLabOrders] = useState(false);

  const [selectedLab, setSelectedLab] = useState(null);
  const [selectedPharmacy, setSelectedPharmacy] = useState(null);

  //forVitals
  const [sys, setSys] = useState("");
  const [dia, setDia] = useState("");
  const [bmiValue, setBmiValue] = useState("");
  const [height, setHeight] = useState("");
  const [weight, setWeight] = useState("");
  const [pulse, setPulse] = useState("");
  const [heartRate, setHeartRate] = useState("");
  const [respirationRate, setRespirationRate] = useState("");
  const [temp, setTemp] = useState("");

  // Speciality form
  const [specialityForm, setSpecialityForm] = useState(null);
  const [specialityDetails, setSpecialityDetails] = useState(null);
  const loggedUserObj = sessionStorage.getItem("login_result");
  const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;

  // Suggestive Treatment or cds
  const [suggestiveData, setSuggestiveData] = useState([]);
  const [suggestiveMedData, setSuggestiveMedData] = useState([]);
  const [symptomsList, setSymptomsList] = useState([]);
  const [selectedSymObj, setSelectedSympObj] = useState(null);

  // Consent state
  const [btnDisable, setBtnDisable] = useState(false);

  //queue modal states
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isVerticalOpen, setIsVerticalOpen] = useState(true);

  // medical History permission Data
  const [permissionData, setPermissionData] = useState(null);

  //consiltation link sharing states
  const [shareModal, setShareModal] = useState(false);
  const [sendValue, setSendValue] = useState("");

  //videi call
  const [videoUrl, setUrl] = useState("");
  const [videoUrlExt, setUrlExt] = useState(null);
  const [videoUrlExtView, setUrlExtView] = useState(false);
  //audio record
  const [showRecorder, setShowRecorder] = useState(false);
  //get vitals master
  const [vitalMaster, setVitalMaster] = useState([]);

  //tabs
  const [activeTab, setActiveTab] = useState("vital");
  const { selectedAppt } = useSelector((state) => state.user);
  const dispatch = useDispatch();

  // Dental
  const [values, setValues] = useState(Array(32).fill(""));
  const [originalValues, setOriginalValues] = useState(Array(32).fill(""));

  // Define sidebar items
  const sidebarItems = [
    { id: "consultationNotes", label: "Consultation Notes", icon: notes },
    { id: "specialtyNotes", label: "Specialty Notes", icon: Speciality },
    { id: "addMedicines", label: "Add Medicines", icon: medicines },
    { id: "addLabTest", label: "Add Lab Test", icon: Lab },
    { id: "treatmentPlan", label: "Treatment Plan", icon: Treatment },
  ];

  useEffect(() => {
    const doctorId = loggedUser?.user?.userId;
    if (!doctorId) return;

    const notificationRef = collection(db, "medicalrecordShare");

    const q = query(
      notificationRef,
      where("receiverId", "==", doctorId),
      where("handled", "==", false),
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      snapshot.docChanges().forEach(async (change) => {
        if (change.type === "added") {
          const data = change.doc.data();

          // Trigger backend
          setTimeout(() => {
            fetchPatientPermission();
            message.success("Patient has updated consent!!");
          }, [2000]);

          // Mark as handled so this does not repeat
          await updateDoc(change.doc.ref, { handled: true });
        }
      });
    });

    return () => unsubscribe();
  }, [loggedUser?.user?.userId]);

  useEffect(() => {
    getVitalMaster();
  }, []);

  useEffect(() => {
    if (selectedAppt !== null) return;

    if (appointmentDetails) {
      dispatch(setSelectedAppt(appointmentDetails));
      return;
    }

    // Acts as a fallback. In any case appointmentDetails comes null!!
    try {
      const apptJson = sessionStorage.getItem("selectedAppt");
      if (apptJson) {
        const apptObj = JSON.parse(apptJson);
        if (apptObj) {
          dispatch(setSelectedAppt(apptObj));
        }
      }
    } catch (error) {
      console.error("Failed to parse selectedAppt from sessionStorage", error);
    }
  }, [appointmentDetails, selectedAppt, dispatch]);

  useEffect(() => {
    const fetchSuggestionData = async () => {
      const payload = {
        complaintCode: appointmentDetails.complaintCode,
        symptomCode: symptomsCode,
      };
      try {
        const response = await ConsultationService.fetchSymptomsList(payload);
        if (response?.data?.data) {
          setSuggestiveMedData(
            response?.data?.data[0]?.diagnosisMedicineMasterList,
          );
        }
      } catch (e) {
        console.error(e);
      }
    };
    if (symptomsCode.length > 0) fetchSuggestionData();
  }, [symptomsCode]);

  //newly added line
  const handleChange = (e, name) => {
    let value = e.target.value;

    setEditPatientDetails((prevDetails) => ({
      ...prevDetails,
      patientId: appointmentDetails.patientId,
      [name]: value,
    }));
  };

  //newly added line
  const handleGender = (value) => {
    setEditPatientDetails((prevDetails) => ({
      ...prevDetails,
      patientId: appointmentDetails.patientId,
      gender: value,
    }));
  };

  const {
    isListening,
    setIsListening,
    recognitionRef,
    chiefComplaintVoice,
    symptomsVoice,
    diseaseConditionVoice,
    icdCodeVoice,
    activeSection,
    setActiveSection,
    vitals,
    setVitals,
    schedule,
    setSchedule,
    refillDate,
    setRefillDate,
    isPreviewModalOpen,
    setIsPreviewModal,
    medicalOpen,
    setMedicalOpen,
    selectedOption,
    setSelectedOption,
    isMicActive,
  } = useContext(VoiceCommandContext);

  useEffect(() => {
    setActiveSection("consultationNotes");
  }, []);

  const toggleMic = () => {
    if (!recognitionRef.current) return;

    if (isListening) {
      recognitionRef.current.stop();
      setIsListening(false);
    } else {
      try {
        recognitionRef.current.start();
        setIsListening(true);
      } catch (error) {
        console.warn("Start error:", error);
      }
    }
  };

  useEffect(() => {
    if (vitals.height) {
      setHeight(vitals.height);
      (hasConsultationId ? handleVitalsUpdate : handleVitals)(
        { target: { value: vitals.height } },
        "cm",
        "HI",
        "Height",
        5,
      );
    }
  }, [vitals.height]);
  useEffect(() => {
    setSchedule(null);
    setRefillDate(null);
  }, []); // runs only when component is mounted

  useEffect(() => {
    if (vitals.weight) {
      setWeight(vitals.weight);
      (hasConsultationId ? handleVitalsUpdate : handleVitals)(
        { target: { value: vitals.weight } },
        "kg",
        "WE",
        "Weight",
        6,
      );
    }
  }, [vitals.weight]);

  useEffect(() => {
    if (vitals.systolic) {
      setSys(vitals.systolic); // ✅ this updates the input
      (hasConsultationId ? handleVitalsUpdate : handleVitals)(
        { target: { value: vitals.systolic } },
        "mmHg",
        "BPS",
        "Blood Pressure(SYS)",
        0,
      );
    }
  }, [vitals.systolic]);

  useEffect(() => {
    if (vitals.diastolic) {
      setDia(vitals.diastolic);
      (hasConsultationId ? handleVitalsUpdate : handleVitals)(
        { target: { value: vitals.diastolic } },
        "mmHg",
        "BPD",
        "Blood Pressure(DIA)",
        1,
      );
    }
  }, [vitals.diastolic]);

  useEffect(() => {
    if (vitals.heartRate) {
      setHeartRate(vitals.heartRate);
      (hasConsultationId ? handleVitalsUpdate : handleVitals)(
        { target: { value: vitals.heartRate } },
        "bpm",
        "HR",
        "Heart Rate",
        2,
      );
    }
  }, [vitals.heartRate]);

  useEffect(() => {
    if (vitals.temperature) {
      setTemp(vitals.temperature);
      (hasConsultationId ? handleVitalsUpdate : handleVitals)(
        { target: { value: vitals.temperature } },
        "°F",
        "TP",
        "Temperature",
        3,
      );
    }
  }, [vitals.temperature]);

  useEffect(() => {
    if (vitals.spo2) {
      setPulse(vitals.spo2);
      (hasConsultationId ? handleVitalsUpdate : handleVitals)(
        { target: { value: vitals.spo2 } },
        "%",
        "SPO2",
        "SPO2",
        4,
      );
    }
  }, [vitals.spo2]);

  useEffect(() => {
    if (vitals.rr) {
      setRespirationRate(vitals.rr);
      (hasConsultationId ? handleVitalsUpdate : handleVitals)(
        { target: { value: vitals.rr } },
        "bpm",
        "RR",
        "Respiratory Rate",
        5,
      );
    }
  }, [vitals.rr]);

  useEffect(() => {
    // Template data loading in the ui.
    if (specialityDetails && specialityForm) {
      specialityForm.forEach((specForm, idx) => {
        const templateItems = document.getElementById(
          `${specForm.templateId}_FIELD_CODES`,
        )?.value;
        let itemsArr;
        if (templateItems) itemsArr = templateItems.split("|");

        if (itemsArr)
          for (let item of itemsArr) {
            if (item) {
              const parentEle = document.getElementById(item);
              if (parentEle) {
                const selectedTemp_TempId = specForm.templateId;
                const selectedTemp = specialityDetails.find(
                  (specDet) => specDet.templateId === selectedTemp_TempId,
                );
                let fieldValue = selectedTemp?.componentDetailsList;
                fieldValue &&
                  fieldValue.forEach((item) => {
                    const element = document.getElementById(item.componentCode);
                    if (element.querySelector('input[type="text"]')) {
                      const formEle =
                        element.querySelector('input[type="text"]');
                      formEle.value = item.componentValue;
                    } else if (element.querySelector('input[type="number"]')) {
                      const formEle = element.querySelector(
                        'input[type="number"]',
                      );
                      formEle.value = item.componentValue;
                    } else if (element.querySelector('input[type="date"]')) {
                      const formEle =
                        element.querySelector('input[type="date"]');
                      formEle.value = item.componentValue
                        ? new Date(item.componentValue)
                            .toISOString()
                            .split("T")[0]
                        : "";
                    } else if (element.querySelector('input[type="time"]')) {
                      const formEle =
                        element.querySelector('input[type="time"]');
                      formEle.value = item.componentValue?.includes(":")
                        ? item.componentValue
                        : new Date(item.componentValue).toLocaleTimeString(
                            "en-GB",
                            { hour: "2-digit", minute: "2-digit" },
                          );
                    } else if (element.querySelector("textarea")) {
                      const formEle = element.querySelector("textarea");
                      formEle.value = item.componentValue;
                    } else if (element.querySelector("select")) {
                      const formEle = element.querySelector("select");
                      formEle.value = item.componentValue;
                    } else if (element.querySelector('input[type="radio"]')) {
                      const formEle = element.querySelectorAll(
                        'input[type="radio"]',
                      );
                      formEle.forEach((radio) => {
                        radio.checked = radio.value === item.componentValue;
                      });
                    } else if (
                      element.querySelector('input[type="checkbox"]')
                    ) {
                      const checkboxes = element.querySelectorAll(
                        'input[type="checkbox"]',
                      );
                      checkboxes.forEach((checkbox) => {
                        const componentVal = item.componentValue.split(",");
                        if (Array.isArray(componentVal)) {
                          checkbox.checked = componentVal.includes(
                            checkbox.value,
                          );
                        } else {
                          checkbox.checked = checkbox.value === componentVal[0];
                        }
                      });
                    }
                  });
              }
            }
          }
      });
    }
  }, [specialityDetails, specialityForm]);

  const fetchSuggestionData = async (payload) => {
    if (loggedUser.user.isSuggestiveMedicine !== "Y") return;
    try {
      const response = await ConsultationService.fetchSymptomsList(payload);
      if (response?.data?.data) {
        setSuggestiveData(response?.data?.data[0]);
        setSuggestiveMedData(
          response?.data?.data[0]?.diagnosisMedicineMasterList,
        );
      }
      setSymptomsList(response?.data?.data[0]?.diagnosisSymptomMasterList);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    if (appointmentDetails.complaintCode && appointmentDetails.status !== 2) {
      let payload = {
        complaintCode: appointmentDetails.complaintCode,
      };
      fetchSuggestionData(payload);
    }
  }, [appointmentDetails.complaintCode, appointmentDetails.consultationId]);

  useEffect(() => {
    // Fetching template form and suggestive med|lab|diagnosis data
    const fetchSpecForm = async () => {
      const specMapTempPayload = {
        userId: loggedUser.user.userId,
        status: 1,
      };
      const templatePayload = {
        templateId: [],
        status: 1,
      };
      try {
        const mappedTemp =
          await ConsultationService.getUserMappedTemp(specMapTempPayload);
        let data = mappedTemp?.data[0].templatesDetails;

        const applicableTemplateIds = data
          .filter((item) => item.applicable === "Y")
          .sort((a, b) => a.seqNo - b.seqNo)
          .map((item) => item.templateId);

        if (applicableTemplateIds.length > 0) {
          templatePayload.templateId = applicableTemplateIds;

          const response =
            await ConsultationService.specialityForm(templatePayload);

          const orderedResponse = applicableTemplateIds
            .map((id) => response.data.find((item) => item.templateId === id))
            .filter(Boolean);

          setSpecialityForm(orderedResponse);
        }
      } catch (e) {
        console.error(e);
      }
    };
    fetchSpecForm();
  }, []);

  useEffect(() => {
    if (weight && height) {
      const heightInMeters = height / 100;
      const bmi = weight / (heightInMeters * heightInMeters);
      setBmiValue(bmi.toFixed(1));
    }
  }, [height, weight]);

  useEffect(() => {
    const handleBmi = (value, units, vitalCode, vitalName, index) => {
      let payload = {
        account_Id: appointmentDetails?.account_Id,
        clinic_Id: appointmentDetails?.clinic_Id,
        userId: appointmentDetails?.userId,
        createdBy: appointmentDetails?.userId,
        createdDate: CommonFunctions.convertUTCDate(
          new Date(),
          "YYYY-MM-DD HH:mm:ss",
        ),
        modifiedBy: appointmentDetails?.userId,
        modifiedDate: CommonFunctions.convertUTCDate(
          new Date(),
          "YYYY-MM-DD HH:mm:ss",
        ),
        patientId: appointmentDetails.patientId,
        recordedDateTime: timestamp,
        status: 1,
        units: units,
        value: value !== "" ? value : "",
        vitalCode: vitalCode,
        vitalName: vitalName,
      };

      setPatientVitals((prevData) => {
        const index = prevData.findIndex(
          (item) => item.vitalCode === vitalCode,
        );

        if (index !== -1) {
          const updatedVitals = [...prevData];
          updatedVitals[index] = payload;
          return updatedVitals;
        } else {
          return prevData.length < 9 ? [...prevData, payload] : prevData;
        }
      });
    };

    const handleBmiUpdate = (value, units, vitalCode, vitalName, index) => {
      let payload = {
        status: 1,
        units,
        value,
        vitalCode,
        vitalName,
      };

      setPatientVitals((prevData) =>
        prevData.map((item) =>
          item.vitalCode === vitalCode || item.units === units
            ? { ...item, ...payload }
            : item,
        ),
      );
    };
    if (bmiValue) {
      (hasConsultationId ? handleBmiUpdate : handleBmi)(
        bmiValue,
        "Kg/m2",
        "BMI",
        "BMI",
        6,
      );
    }
  }, [bmiValue]);

  const getConsultationDetails = () => {
    setLoading(true);
    let payload = {
      patientId: appointmentDetails.patientId,
    };
    PatientService.PatientListFilter(payload)
      .then((result) => {
        setPatientDetails(result.data[0]);
        setChiefComplaints(appointmentDetails.appointmentReason);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching patient list:", error);
        setLoading(false);
      });
    if (appointmentDetails.consultationId) {
      let payload = {
        consultationId: appointmentDetails.consultationId,
        detailsYN: "Y",
      };
      ConsultationService.getPrescriptions(payload).then((result) => {
        setHasConsultationId(true);
        setUpdatePayload(result?.data[0]);
        setPatientVitals(result?.data[0]?.patientVitals);
        setLabPrescription(result?.data[0].labPrescription);
        setDrugPrescription(result?.data[0].drugPrescription);
        setPatientDiagnosisDetails(result?.data[0].patientDiagnosisDetails);
        setSchedule(
          result?.data[0]?.followupVisitDate
            ? dayjs(result.data[0].followupVisitDate)
            : "",
        );
        setRefillDate(
          result?.data[0]?.refillDate ? dayjs(result.data[0].refillDate) : "",
        );
        setRecommentation(
          result?.data[0]?.recommendation ? result.data[0].recommendation : "",
        );
        setSymptoms(result?.data[0]?.symptoms ? result?.data[0]?.symptoms : "");
        setSpecialityDetails(
          result?.data[0]?.specialityDetails
            ? result?.data[0]?.specialityDetails
            : null,
        );
      });

      //if logged user is dental. only for timebeing - DZU5051209
      if (loggedUser.user.userId === "DZU5051209") {
        const dentalPayload = {
          consultationId: appointmentDetails?.consultationId,
          status: 1,
        };
        ConsultationService.getDentalFormData(dentalPayload)
          .then((res) => {
            // Need to set the c1 to c32 values to setValues state
            const dentalData = res.data[0];
            const filteredVal = Array.from(
              { length: 32 },
              (_, i) => dentalData[`c${i + 1}`] || "",
            );
            setValues(filteredVal || Array(32).fill(""));
            setOriginalValues(filteredVal || Array(32).fill(""));
          })
          .catch((e) => console.error(e));
      }
    }
  };
  useEffect(() => {
    getConsultationDetails();
  }, [appointmentDetails.patientId]);

  const getVitalValue = (code) => {
    const value = updatePayload?.patientVitals?.find(
      (item) => item.vitalCode === code,
    )?.value;

    return value === 0 || value === "0" ? "" : value || "";
  };

  useEffect(() => {
    setSys(getVitalValue("BPS"));
    setDia(getVitalValue("BPD"));
    // setBmiValue(getVitalValue("BMI")); // Uncomment if needed
    setHeight(getVitalValue("HI"));
    setWeight(getVitalValue("WE"));
    setPulse(getVitalValue("SPO2"));
    setHeartRate(getVitalValue("HR"));
    setRespirationRate(getVitalValue("RR"));
    setTemp(getVitalValue("TP"));
  }, [appointmentDetails.consultationId && updatePayload]);

  useEffect(() => {
    const getRecentVitals = async (patientId) => {
      try {
        let payload1 = {
          patientId: patientId,
          vitalCodes: "HI",
        };

        let result1 = await VitalService.getSpecificVitalData(payload1);

        const height = result1?.data?.find(
          (item) => item.vitalCode === "HI",
        )?.value;

        let payload2 = {
          patientId: patientId,
          vitalCodes: "WE",
        };

        let result2 = await VitalService.getSpecificVitalData(payload2);

        const weight = result2?.data?.find(
          (item) => item.vitalCode === "WE",
        )?.value;

        setHeight(height === "0" || height === 0 ? "" : height || "");
        setWeight(weight === "0" || weight === 0 ? "" : weight || "");
      } catch (error) {
        console.error("Error fetching vitals:", error);
      }
    };

    if (!appointmentDetails.consultationId) {
      getRecentVitals(appointmentDetails.patientId);
    }
  }, []);

  const handleVitals = (e, units, vitalCode, vitalName, index) => {
    let value = e.target.value;
    let payload = {
      account_Id: appointmentDetails?.account_Id,
      clinic_Id: appointmentDetails?.clinic_Id,
      userId: appointmentDetails?.userId,
      createdBy: appointmentDetails?.userId,
      createdDate: CommonFunctions.convertUTCDate(
        new Date(),
        "YYYY-MM-DD HH:mm:ss",
      ),
      modifiedDate: CommonFunctions.convertUTCDate(
        new Date(),
        "YYYY-MM-DD HH:mm:ss",
      ),
      modifiedBy: appointmentDetails?.userId,
      patientId: appointmentDetails.patientId,
      recordedDateTime: timestamp,
      status: 1,
      units: units,
      value: value !== "" ? value : "",
      vitalCode: vitalCode,
      vitalName: vitalName,
    };
    setPatientVitals((prevData) => {
      const index = prevData.findIndex((item) => item.vitalCode === vitalCode);

      if (index !== -1) {
        const updatedVitals = [...prevData];
        updatedVitals[index] = payload;
        return updatedVitals;
      } else {
        return prevData.length < 9 ? [...prevData, payload] : prevData;
      }
    });
  };

  const handleVitalsUpdate = (e, units, vitalCode, vitalName, index) => {
    let value = e.target.value;
    let payload = {
      status: 1,
      units,
      value,
      vitalCode,
      vitalName,
    };

    setPatientVitals((prevData) =>
      prevData.map((item) =>
        item.vitalCode === vitalCode ? { ...item, ...payload } : item,
      ),
    );
  };

  const handleKeyPress = (e) => {
    const allowedKeys = [
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      ".",
      "Backspace",
      "Delete",
      "ArrowLeft",
      "ArrowRight",
      "Tab",
      ".",
    ];
    if (!allowedKeys.includes(e.key)) {
      e.preventDefault();
    }
  };

  const getVitalMaster = async () => {
    let payload = {
      status: 1,
    };
    try {
      let result = await VitalService.VitalMasterlist(payload);
      setVitalMaster(result.data);
    } catch (error) {
      console.error(error);
    }
  };

  const timestamp = CommonFunctions.convertUTCDate(
    new Date(),
    "YYYY-MM-DD HH:mm:ss",
  );

  const deleteFirebaseCall = async (roomId) => {
    try {
      const callRef = doc(db, "calls", roomId);
      const snap = await getDoc(callRef);
      if (!snap.exists()) return;

      const callData = snap.data();
      const callerId = callData?.incomingCall?.callerId;

      if (callerId !== loggedUser?.user?.userId) {
        console.warn("Non-caller attempted to delete call. Ignored.");
        return;
      }

      await deleteDoc(callRef);
    } catch (err) {
      console.error("Error deleting Firebase call:", err);
    }
  };

  const cleanupCallAfterConsultationEnd = async (appointmentId) => {
    if (!appointmentId) {
      console.warn("cleanupCallAfterConsultationEnd: no appointmentId");
      return;
    }
    try {
      console.log("Cleaning up call doc for:", appointmentId); // ← temporary debug log
      const callRef = doc(db, "calls", appointmentId);
      const snap = await getDoc(callRef);
      if (snap.exists()) {
        await deleteDoc(callRef);
        console.log("Call doc deleted successfully");
      } else {
        console.log("Call doc already gone — nothing to delete");
      }
    } catch (err) {
      console.error("cleanupCallAfterConsultationEnd error:", err);
    }
  };

  const endConsultation = async (type) => {
    setLoading(true);
    let finalSpecArr = [];
    let componentDetailsArr = [];
    specialityForm &&
      specialityForm.forEach((specForm) => {
        // Speciality template data handling starts here. Added new field in end|update|preconsultation.
        const templateItems = document.getElementById(
          `${specForm.templateId}_FIELD_CODES`,
        )?.value;
        const templateLabels = document.getElementById(
          `${specForm.templateId}_FIELD_LABELS`,
        )?.value;
        const specialityObj = {
          userId: appointmentDetails?.userId,
          patientId: appointmentDetails.patientId,
          templateId: specForm.templateId,
          templateName: specForm?.templateName,
          componentDetailsList: [],
          createdBy: appointmentDetails?.userId,
          createdDate:
            type === "update"
              ? specialityDetails[0]?.createdDate
              : CommonFunctions.convertUTCDate(
                  new Date(),
                  "YYYY-MM-DD HH:mm:ss",
                ),
          modifiedBy: appointmentDetails?.userId,
          modifiedDate: CommonFunctions.convertUTCDate(
            new Date(),
            "YYYY-MM-DD HH:mm:ss",
          ),
        };
        let itemsArr;
        let labelsArr;
        if (templateItems) itemsArr = templateItems.split("|");
        if (templateLabels) labelsArr = templateLabels.split("|");

        if (itemsArr)
          for (let item in itemsArr) {
            if (itemsArr[item]) {
              const parentEle = document.getElementById(itemsArr[item]);
              let componentValue = null;

              if (parentEle) {
                if (parentEle.querySelector('input[type="checkbox"]')) {
                  const checkedBoxes = parentEle.querySelectorAll(
                    'input[type="checkbox"]:checked',
                  );
                  componentValue = Array.from(checkedBoxes)
                    .map((cb) => cb.value)
                    .join(",");
                } else if (parentEle.querySelector('input[type="radio"]')) {
                  const selectedRadio = parentEle.querySelector(
                    'input[type="radio"]:checked',
                  );
                  componentValue = selectedRadio ? selectedRadio.value : null;
                } else if (parentEle.querySelector("select")) {
                  const selectEle = parentEle.querySelector("select");
                  componentValue = selectEle ? selectEle.value : null;
                } else {
                  const inputEle = parentEle.querySelector("input, textarea");
                  componentValue = inputEle ? inputEle.value : null;
                }
              }

              const obj = {
                componentCode: itemsArr[item],
                componentValue: componentValue,
                componentLabel: labelsArr[item],
                status: 1,
              };

              if (parentEle) {
                if (obj.componentValue) componentDetailsArr.push(obj);
              }
            }
          }
        specialityObj.componentDetailsList = componentDetailsArr;
        if (appointmentDetails?.consultationId) {
          specialityObj.consultationId = appointmentDetails?.consultationId;
        }
        componentDetailsArr = [];
        finalSpecArr.push(specialityObj);
        // Speciality template data handling ends here
      });

    let payload = {
      account_Id: appointmentDetails?.account_Id,
      clinic_Id: appointmentDetails?.clinic_Id,
      consultationDate: CommonFunctions.convertUTCDate(
        new Date(),
        "YYYY-MM-DD HH:mm:ss",
      ),
      consultationReason: chiefComplaints
        ? chiefComplaints
        : appointmentDetails.appointmentReason,
      consultationType: appointmentDetails?.serviceName,
      createdBy: appointmentDetails?.userId,
      createdDate: CommonFunctions.convertUTCDate(
        new Date(),
        "YYYY-MM-DD HH:mm:ss",
      ),
      image: "",
      imageName: null,
      imageType: null,
      modifiedBy: appointmentDetails?.userId,
      modifiedDate: CommonFunctions.convertUTCDate(
        new Date(),
        "YYYY-MM-DD HH:mm:ss",
      ),
      patientDocumentID: 0,
      patientId: appointmentDetails.patientId,
      status: 1,
      userId: appointmentDetails?.userId,
      appointmentId: appointmentDetails.appointmentId,
      specialityCode: appointmentDetails.specialityCode,
      symptoms: symptoms,
      recommendation: recommentation,
      followupVisitDate: schedule ? dayjs(schedule).format("MM/DD/YYYY") : "",
      refillDate: refillDate ? dayjs(refillDate).format("MM/DD/YYYY") : "",
      patientVitals: patientVitals,
      labPrescription: labPrescription,
      drugPrescription: drugPrescription,
      patientDiagnosisDetails: patientDiagnosisDetails,
      specialityDetails: finalSpecArr,
    };
    if (type === "end") {
      setIsListening(false);
      let vit = {
        HR: heartRate,
        BMI: bmiValue,
        BPD: dia,
        BPS: sys,
        SPO2: pulse,
        RR: respirationRate,
        WE: weight,
        HI: height,
        TP: temp,
      };
      if (Object.values(vit).every((val) => !val)) {
        payload.patientVitals = [];
      } else {
        const finalVitalsArray = vitalMaster.map((vital) => ({
          account_Id: appointmentDetails?.account_Id,
          clinic_Id: appointmentDetails?.clinic_Id,
          userId: appointmentDetails?.userId,
          createdBy: appointmentDetails?.userId,
          createdDate: CommonFunctions.convertUTCDate(
            new Date(),
            "YYYY-MM-DD HH:mm:ss",
          ),
          modifiedDate: CommonFunctions.convertUTCDate(
            new Date(),
            "YYYY-MM-DD HH:mm:ss",
          ),
          modifiedBy: appointmentDetails?.userId,
          patientId: appointmentDetails.patientId,
          recordedDateTime: timestamp,
          status: 1,
          units: vital.units,
          value: vit[vital.vitalCode] || "0",
          vitalCode: vital.vitalCode,
          vitalName: vital.vitalName,
          rpmApplicable: patientDetails?.rpmApplicable,
        }));
        payload.patientVitals = finalVitalsArray;
      }
      try {
        let endResult = await ConsultationService.ConsultationNotes(payload);
        if (endResult.data.status !== -1) {
          if (medicineOrders) {
            await onMedicineOrderSend(
              appointmentDetails,
              selectedPharmacy,
              drugPrescription,
              endResult.data.consultationId,
            );
          }

          if (labOrders) {
            await onLabOrderSend(
              appointmentDetails,
              selectedLab,
              endResult.data.consultationId,
            );
          }
          let endPayload = {
            appointmentId: appointmentDetails.appointmentId,
            consultationId: endResult.data.consultationId,
            patientId: appointmentDetails.patientId,
            userId: appointmentDetails.userId,
            transactionId: appointmentDetails.transactionId,
          };
          const isDentalFormEmpty = values.every(
            (val) => !val || val.trim() === "",
          );
          if (
            appointmentDetails.userId === "DZU5051209" &&
            !isDentalFormEmpty
          ) {
            const dentalPayload = {
              accountId: appointmentDetails?.account_Id,
              appointmentId: appointmentDetails?.appointmentId,
              clinicId: appointmentDetails?.clinic_Id,
              consultationId: endResult.data.consultationId,
              createdBy: appointmentDetails?.userId,
              createdDate: CommonFunctions.convertUTCDate(
                new Date(),
                "YYYY-MM-DD HH:mm:ss",
              ),
              modifiedBy: appointmentDetails?.userId,
              modifiedDate: CommonFunctions.convertUTCDate(
                new Date(),
                "YYYY-MM-DD HH:mm:ss",
              ),
              patientId: appointmentDetails.patientId,
              userId: appointmentDetails.userId,
              status: 1,
              ...Object.fromEntries(values.map((v, i) => [`c${i + 1}`, v])),
            };
            await Promise.all([
              ConsultationService.dentalFormSave(dentalPayload),
              ConsultationService.EndConsultation(endPayload),
            ]);
          } else {
            await ConsultationService.EndConsultation(endPayload);
          }
          sessionStorage.removeItem("selectedAppt");
          message.success(
            "Your consultation ended successfully, e-prescription will be shared with patient.",
          );

          if (Object.keys(editedPatientDetails).length > 0) {
            let updatepatientDetails =
              await ConsultationService.UpdatePatientDetailsInConsultation(
                editedPatientDetails,
              );
          }
          if (audioRef?.current) {
            await audioRef.current.stopRecordingFromParent();
          }
          history.push(APP_ROUTES.DASHBOARD);
          setLoading(false);
        } else {
          message.error("Error occurred. Please try after sometime.");
          setLoading(false);
        }
      } catch (error) {
        message.error("An Error occured, Please try again.");
        setLoading(false);
      } finally {
        await cleanupCallAfterConsultationEnd(appointmentDetails.appointmentId);
        setLoading(false);
      }
    }
    if (type === "update") {
      setIsListening(false);
      setLoading(true);
      updatePayload.patientVitals = payload.patientVitals;
      if (patientVitals.length === 0) {
        let vit = {
          HR: heartRate,
          BMI: bmiValue,
          BPD: dia,
          BPS: sys,
          SPO2: pulse,
          RR: respirationRate,
          WE: weight,
          HI: height,
          TP: temp,
        };

        if (Object.values(vit).every((val) => !val)) {
          updatePayload.patientVitals = payload.patientVitals;
        } else {
          const finalVitalsArray = vitalMaster.map((vital) => ({
            account_Id: appointmentDetails?.account_Id,
            clinic_Id: appointmentDetails?.clinic_Id,
            userId: appointmentDetails?.userId,
            createdBy: appointmentDetails?.userId,
            createdDate: CommonFunctions.convertUTCDate(
              new Date(),
              "YYYY-MM-DD HH:mm:ss",
            ),
            modifiedDate: CommonFunctions.convertUTCDate(
              new Date(),
              "YYYY-MM-DD HH:mm:ss",
            ),
            modifiedBy: appointmentDetails?.userId,
            patientId: appointmentDetails.patientId,
            recordedDateTime: timestamp,
            status: 1,
            units: vital.units,
            value: vit[vital.vitalCode] || "0",
            vitalCode: vital.vitalCode,
            vitalName: vital.vitalName,
            rpmApplicable: patientDetails?.rpmApplicable,
          }));
          updatePayload.patientVitals = finalVitalsArray;
        }
      }
      updatePayload.drugPrescription = drugPrescription;
      updatePayload.patientDiagnosisDetails = patientDiagnosisDetails;
      updatePayload.labPrescription = labPrescription;
      updatePayload.recommendation = recommentation;
      updatePayload.followupVisitDate = schedule
        ? dayjs(schedule).format("MM/DD/YYYY")
        : "";
      updatePayload.refillDate = refillDate
        ? dayjs(refillDate).format("MM/DD/YYYY")
        : "";
      updatePayload.symptoms = symptoms;
      updatePayload.specialityDetails = finalSpecArr;
      try {
        const isDentalChanged = (current, original) => {
          return current.some((val, i) => val !== original[i]);
        };
        const isChanged = isDentalChanged(values, originalValues);

        if (appointmentDetails.userId === "DZU5051209" && isChanged) {
          // if doctor is dental
          const res = await ConsultationService.getDentalFormData({
            consultationId: appointmentDetails?.consultationId,
          });
          const dentalPayload = {
            ...res.data[0],
            modifiedBy: appointmentDetails?.userId,
            modifiedDate: CommonFunctions.convertUTCDate(
              new Date(),
              "YYYY-MM-DD HH:mm:ss",
            ),
            status: 1,
            ...Object.fromEntries(values.map((v, i) => [`c${i + 1}`, v])),
          };
          await ConsultationService.dentalFormUpdate(dentalPayload);
        }

        let result =
          await ConsultationService.updateConsultation(updatePayload);
        if (Object.keys(editedPatientDetails).length > 0) {
          let updatepatientDetails =
            await ConsultationService.UpdatePatientDetailsInConsultation(
              editedPatientDetails,
            );
        }
        message.success("Your consultation Updated successfully");
        history.push(APP_ROUTES.DASHBOARD);
        setLoading(false);
      } catch (error) {
        message.error("An occured while updating please try again");
        console.error(error);
        setLoading(false);
      }
    }

    if (type === "preConsult") {
      setIsListening(false);
      setLoading(true);
      updatePayload.patientVitals = payload.patientVitals;
      if (patientVitals.length === 0) {
        let vit = {
          HR: heartRate,
          BMI: bmiValue,
          BPD: dia,
          BPS: sys,
          SPO2: pulse,
          RR: respirationRate,
          WE: weight,
          HI: height,
          TP: temp,
        };

        if (Object.values(vit).every((val) => !val)) {
          updatePayload.patientVitals = payload.patientVitals;
        } else {
          const finalVitalsArray = vitalMaster.map((vital) => ({
            account_Id: appointmentDetails?.account_Id,
            clinic_Id: appointmentDetails?.clinic_Id,
            userId: appointmentDetails?.userId,
            createdBy: appointmentDetails?.userId,
            createdDate: CommonFunctions.convertUTCDate(
              new Date(),
              "YYYY-MM-DD HH:mm:ss",
            ),
            modifiedDate: CommonFunctions.convertUTCDate(
              new Date(),
              "YYYY-MM-DD HH:mm:ss",
            ),
            modifiedBy: appointmentDetails?.userId,
            patientId: appointmentDetails.patientId,
            recordedDateTime: timestamp,
            status: 1,
            units: vital.units,
            value: vit[vital.vitalCode] || "0",
            vitalCode: vital.vitalCode,
            vitalName: vital.vitalName,
            rpmApplicable: patientDetails?.rpmApplicable,
          }));
          updatePayload.patientVitals = finalVitalsArray;
        }
      }
      updatePayload.drugPrescription = drugPrescription;
      updatePayload.patientDiagnosisDetails = patientDiagnosisDetails;
      updatePayload.labPrescription = labPrescription;
      updatePayload.recommendation = recommentation;
      updatePayload.followupVisitDate = schedule
        ? dayjs(schedule).format("MM/DD/YYYY")
        : "";
      updatePayload.refillDate = refillDate
        ? dayjs(refillDate).format("MM/DD/YYYY")
        : "";
      updatePayload.symptoms = symptoms;
      updatePayload.specialityDetails = finalSpecArr;
      try {
        let result =
          await ConsultationService.updateConsultation(updatePayload);
        let endPayload = {
          appointmentId: appointmentDetails.appointmentId,
          consultationId: updatePayload.consultationId,
          patientId: appointmentDetails.patientId,
          userId: appointmentDetails.userId,
          transactionId: appointmentDetails.transactionId,
        };
        const isDentalFormEmpty = values.every(
          (val) => !val || val.trim() === "",
        );

        if (appointmentDetails.userId === "DZU5051209" && !isDentalFormEmpty) {
          const dentalPayload = {
            accountId: appointmentDetails?.account_Id,
            appointmentId: appointmentDetails?.appointmentId,
            clinicId: appointmentDetails?.clinic_Id,
            consultationId: updatePayload.consultationId,
            createdBy: appointmentDetails?.userId,
            createdDate: CommonFunctions.convertUTCDate(
              new Date(),
              "YYYY-MM-DD HH:mm:ss",
            ),
            modifiedBy: appointmentDetails?.userId,
            modifiedDate: CommonFunctions.convertUTCDate(
              new Date(),
              "YYYY-MM-DD HH:mm:ss",
            ),
            patientId: appointmentDetails.patientId,
            userId: appointmentDetails.userId,
            status: 1,
            ...Object.fromEntries(values.map((v, i) => [`c${i + 1}`, v])),
          };
          await Promise.all([
            ConsultationService.dentalFormSave(dentalPayload),
            ConsultationService.EndConsultation(endPayload),
          ]);
        } else {
          await ConsultationService.EndConsultation(endPayload);
        }
        if (Object.keys(editedPatientDetails).length > 0) {
          let updatepatientDetails =
            await ConsultationService.UpdatePatientDetailsInConsultation(
              editedPatientDetails,
            );
        }
        await cleanupCallAfterConsultationEnd(appointmentDetails.appointmentId);
        sessionStorage.removeItem("selectedAppt");
        message.success(
          "Your consultation ended successfully, e-prescription will be shared with patient.",
        );
        history.push(APP_ROUTES.DASHBOARD);
        setLoading(false);
      } catch (error) {
        message.error("An occured while updating please try again");
        console.error(error);
        setLoading(false);
      }
    }

    if (type === "preview") {
      let vit = {
        HR: heartRate,
        BMI: bmiValue,
        BPD: dia,
        BPS: sys,
        SPO2: pulse,
        RR: respirationRate,
        WE: weight,
        HI: height,
        TP: temp,
      };

      if (Object.values(vit).every((val) => !val)) {
        payload.patientVitals = [];
      } else {
        const finalVitalsArray = vitalMaster.map((vital) => ({
          account_Id: appointmentDetails?.account_Id,
          clinic_Id: appointmentDetails?.clinic_Id,
          userId: appointmentDetails?.userId,
          createdBy: appointmentDetails?.userId,
          createdDate: CommonFunctions.convertUTCDate(
            new Date(),
            "YYYY-MM-DD HH:mm:ss",
          ),
          modifiedDate: CommonFunctions.convertUTCDate(
            new Date(),
            "YYYY-MM-DD HH:mm:ss",
          ),
          modifiedBy: appointmentDetails?.userId,
          patientId: appointmentDetails.patientId,
          recordedDateTime: timestamp,
          status: 1,
          units: vital.units,
          value: vit[vital.vitalCode] || "",
          vitalCode: vital.vitalCode,
          vitalName: vital.vitalName,
          rpmApplicable: patientDetails?.rpmApplicable,
        }));
        payload.patientVitals = finalVitalsArray;
      }
      if (
        payload &&
        payload.specialityDetails?.every(
          (item) => item.componentDetailsList.length === 0,
        )
      ) {
        payload.specialityDetails = [];
      }
      // payload.patientVitals = patientVitals;
      payload.labPrescription = labPrescription;
      payload.drugPrescription = drugPrescription;
      payload.patientDiagnosisDetails = patientDiagnosisDetails;

      const isDentalFormEmpty = values.every(
        (val) => !val || val.trim() === "",
      );
      if (appointmentDetails.userId === "DZU5051209" && !isDentalFormEmpty) {
        const dentalPayload = {
          accountId: appointmentDetails?.account_Id,
          appointmentId: appointmentDetails?.appointmentId,
          clinicId: appointmentDetails?.clinic_Id,
          consultationId: "",
          createdBy: appointmentDetails?.userId,
          createdDate: CommonFunctions.convertUTCDate(
            new Date(),
            "YYYY-MM-DD HH:mm:ss",
          ),
          modifiedBy: appointmentDetails?.userId,
          modifiedDate: CommonFunctions.convertUTCDate(
            new Date(),
            "YYYY-MM-DD HH:mm:ss",
          ),
          patientId: appointmentDetails.patientId,
          userId: appointmentDetails.userId,
          status: 1,
          ...Object.fromEntries(values.map((v, i) => [`c${i + 1}`, v])),
        };
        payload.dentalDetails = dentalPayload;
      }
      setPreviewData(payload);
      setIsPreviewModal(true);
      setLoading(false);
      return;
    }
  };

  const saveDraft = async () => {
    setLoading(true);
    await cleanupCallAfterConsultationEnd(appointmentDetails.appointmentId);
    sessionStorage.removeItem("selectedAppt");
    let payload = {
      account_Id: appointmentDetails?.account_Id,
      clinic_Id: appointmentDetails?.clinic_Id,
      consultationDate: CommonFunctions.convertUTCDate(
        new Date(),
        "YYYY-MM-DD HH:mm:ss",
      ),
      consultationReason: chiefComplaints
        ? chiefComplaints
        : appointmentDetails.appointmentReason,
      consultationType: appointmentDetails?.serviceName,
      createdBy: appointmentDetails?.userId,
      createdDate: CommonFunctions.convertUTCDate(
        new Date(),
        "YYYY-MM-DD HH:mm:ss",
      ),
      image: "",
      imageName: null,
      imageType: null,
      modifiedBy: appointmentDetails?.userId,
      modifiedDate: CommonFunctions.convertUTCDate(
        new Date(),
        "YYYY-MM-DD HH:mm:ss",
      ),
      patientDocumentID: 0,
      patientId: appointmentDetails.patientId,
      status: 1,
      userId: appointmentDetails?.userId,
      appointmentId: appointmentDetails.appointmentId,
      specialityCode: appointmentDetails.specialityCode,
      symptoms: symptoms,
      recommendation: recommentation,
      followupVisitDate: schedule ? dayjs(schedule).format("MM/DD/YYYY") : "",
      refillDate: refillDate ? dayjs(refillDate).format("MM/DD/YYYY") : "",
      labPrescription: labPrescription,
      drugPrescription: drugPrescription,
      patientDiagnosisDetails: patientDiagnosisDetails,
    };
    if (appointmentDetails.consultationId) {
      updatePayload.patientVitals = payload.patientVitals;
      if (patientVitals.length === 0) {
        let vit = {
          HR: heartRate,
          BMI: bmiValue,
          BPD: dia,
          BPS: sys,
          SPO2: pulse,
          RR: respirationRate,
          WE: weight,
          HI: height,
          TP: temp,
        };

        if (Object.values(vit).every((val) => !val)) {
          updatePayload.patientVitals = payload.patientVitals;
        } else {
          const finalVitalsArray = vitalMaster.map((vital) => ({
            account_Id: appointmentDetails?.account_Id,
            clinic_Id: appointmentDetails?.clinic_Id,
            userId: appointmentDetails?.userId,
            createdBy: appointmentDetails?.userId,
            createdDate: CommonFunctions.convertUTCDate(
              new Date(),
              "YYYY-MM-DD HH:mm:ss",
            ),
            modifiedDate: CommonFunctions.convertUTCDate(
              new Date(),
              "YYYY-MM-DD HH:mm:ss",
            ),
            modifiedBy: appointmentDetails?.userId,
            patientId: appointmentDetails.patientId,
            recordedDateTime: timestamp,
            status: 1,
            units: vital.units,
            value: vit[vital.vitalCode] || "0",
            vitalCode: vital.vitalCode,
            vitalName: vital.vitalName,
            rpmApplicable: patientDetails?.rpmApplicable,
          }));
          updatePayload.patientVitals = finalVitalsArray;
        }
      }
      updatePayload.drugPrescription = drugPrescription;
      updatePayload.patientDiagnosisDetails = patientDiagnosisDetails;
      updatePayload.labPrescription = labPrescription;
      updatePayload.recommendation = recommentation;
      updatePayload.followupVisitDate = schedule
        ? dayjs(schedule).format("MM/DD/YYYY")
        : "";
      updatePayload.refillDate = refillDate
        ? dayjs(refillDate).format("MM/DD/YYYY")
        : "";
      updatePayload.symptoms = symptoms;

      try {
        let result =
          await ConsultationService.updateConsultation(updatePayload);
        const isDentalChanged = (current, original) => {
          return current.some((val, i) => val !== original[i]);
        };
        const isChanged = isDentalChanged(values, originalValues);

        if (appointmentDetails.userId === "DZU5051209" && isChanged) {
          // if doctor is dental
          const res = await ConsultationService.getDentalFormData({
            consultationId: appointmentDetails?.consultationId,
          });
          const dentalPayload = {
            ...res.data[0],
            modifiedBy: appointmentDetails?.userId,
            modifiedDate: CommonFunctions.convertUTCDate(
              new Date(),
              "YYYY-MM-DD HH:mm:ss",
            ),
            status: 1,
            ...Object.fromEntries(values.map((v, i) => [`c${i + 1}`, v])),
          };
          await ConsultationService.dentalFormUpdate(dentalPayload);
        }
        if (Object.keys(editedPatientDetails).length > 0) {
          let updatepatientDetails =
            await ConsultationService.UpdatePatientDetailsInConsultation(
              editedPatientDetails,
            );
        }
        message.success("Consultation is save in Draft");
        history.push(APP_ROUTES.DASHBOARD);
        setLoading(false);
      } catch (error) {
        message.error("An occured while updating please try again");
        console.error(error);
        setLoading(false);
      }
    } else {
      let vit = {
        HR: heartRate,
        BMI: bmiValue,
        BPD: dia,
        BPS: sys,
        SPO2: pulse,
        RR: respirationRate,
        WE: weight,
        HI: height,
        TP: temp,
      };

      const finalVitalsArray = vitalMaster.map((vital) => ({
        account_Id: appointmentDetails?.account_Id,
        clinic_Id: appointmentDetails?.clinic_Id,
        userId: appointmentDetails?.userId,
        createdBy: appointmentDetails?.userId,
        createdDate: CommonFunctions.convertUTCDate(
          new Date(),
          "YYYY-MM-DD HH:mm:ss",
        ),
        modifiedDate: CommonFunctions.convertUTCDate(
          new Date(),
          "YYYY-MM-DD HH:mm:ss",
        ),
        modifiedBy: appointmentDetails?.userId,
        patientId: appointmentDetails.patientId,
        recordedDateTime: timestamp,
        status: 1,
        units: vital.units,
        value: vit[vital.vitalCode] || "0",
        vitalCode: vital.vitalCode,
        vitalName: vital.vitalName,
        rpmApplicable: patientDetails?.rpmApplicable,
      }));
      payload.patientVitals = finalVitalsArray;

      try {
        let endResult = await ConsultationService.ConsultationNotes(payload);
        const isDentalFormEmpty = values.every(
          (val) => !val || val.trim() === "",
        );

        if (appointmentDetails.userId === "DZU5051209" && !isDentalFormEmpty) {
          const dentalPayload = {
            accountId: appointmentDetails?.account_Id,
            appointmentId: appointmentDetails?.appointmentId,
            clinicId: appointmentDetails?.clinic_Id,
            consultationId: endResult.data.consultationId,
            createdBy: appointmentDetails?.userId,
            createdDate: CommonFunctions.convertUTCDate(
              new Date(),
              "YYYY-MM-DD HH:mm:ss",
            ),
            modifiedBy: appointmentDetails?.userId,
            modifiedDate: CommonFunctions.convertUTCDate(
              new Date(),
              "YYYY-MM-DD HH:mm:ss",
            ),
            patientId: appointmentDetails.patientId,
            userId: appointmentDetails.userId,
            status: 1,
            ...Object.fromEntries(values.map((v, i) => [`c${i + 1}`, v])),
          };
          await ConsultationService.dentalFormSave(dentalPayload);
        }
        if (Object.keys(editedPatientDetails).length > 0) {
          let updatepatientDetails =
            await ConsultationService.UpdatePatientDetailsInConsultation(
              editedPatientDetails,
            );
        }
        history.push(APP_ROUTES.DASHBOARD);
        message.success("Consultation is saved in Draft");
      } catch (error) {
        message.error("An Error occured, Please try again.");
        setLoading(false);
      } finally {
        setLoading(false);
      }
    }
  };

  const fetchUrl = (value) => {
    setUrl(value);
  };

  const handleFullScreen = () => {
    // window.open(videoUrl, "_blank").focus();
    setUrlExt(videoUrl);
    setUrlExtView(true);
  };
  //video call part end

  //share consultation link start

  const showShareModal = () => {
    setShareModal(true);
  };

  const handleShareLink = () => {
    const enteredVal = sendValue;
    var validation =
      /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})|([0-9]{10})+$/;
    var number = /^\d+$/;
    let payload = {};
    setLoading(true);
    if (validation.test(enteredVal)) {
      if (number.test(enteredVal)) {
        payload.mobile = enteredVal;
      } else {
        payload.email = enteredVal;
      }
      payload.patientId = appointmentDetails.patientId;
      payload.userId = appointmentDetails.userId;
      payload.consultationType = appointmentDetails.consultationType;
      payload.appointmentId = appointmentDetails.appointmentId;

      enrollmentServices
        .InvitationShare(payload)
        .then((res) => {
          message.success("Invitation sent successfully");
          setShareModal(false);
          setLoading(false);
          setSendValue("");
        })
        .catch((e) => {
          message.error("An error occurred, Try again");
          setLoading(false);
        });
    } else {
      message.error("Please enter the valid email or phone");
      setLoading(false);
    }
  };
  //share consultation link end

  //Medical History Start

  const handleClick = () => {
    setMedicalOpen(true);
    fetchPatientPermission();
  };
  const handleMedicalCancel = () => {
    setMedicalOpen(false);
    setPermissionData(null);
    setSelectedOption(null);
  };
  const convertUTCDateForAccess = (date, format = "MM/DD/YYYY") => {
    return dayjs.utc(date).add(2, "minute").format(format);
  };
  const fetchPatientPermission = async () => {
    const userObj = sessionStorage.getItem("login_result");
    const userData = userObj ? JSON.parse(userObj) : null;
    const patientObj = sessionStorage.getItem("patient");
    const patientData = patientObj ? JSON.parse(patientObj) : null;

    const currDate = new Date().toISOString();
    const date = currDate.split("T")[0];
    const time = currDate.split("T")[1].slice(0, 8);
    const constructedTime = date + " " + time;

    let permissionPayload = {
      patientId: patientData.patientId,
      userId: userData?.user?.userId,
      accessDate: convertUTCDateForAccess(new Date(), "YYYY-MM-DD HH:mm:ss"),
      status: 1,
    };
    setIsLoading(true);
    try {
      const response =
        await PatientService.isPermissionGranted(permissionPayload);
      if (response?.data?.length !== 0) {
        if (response?.data[0]) {
          setPermissionData(response?.data[0]);
        }
      }
      setIsLoading(false);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    if (permissionData) {
      if (permissionData.medicalHistory === "Y") {
        setSelectedOption("Medical history");
      } else if (permissionData.prescription === "Y") {
        setSelectedOption("Prescription");
      } else if (permissionData.vitals === "Y") {
        setSelectedOption("Vitals");
      } else if (permissionData.reports === "Y") {
        setSelectedOption("Reports");
      }
    }
  }, [permissionData]);

  const handleOptionChange = (option) => {
    if (permissionData) {
      if (
        option === "Medical history" &&
        permissionData.medicalHistory === "Y"
      ) {
        setSelectedOption(option);
      } else if (
        option === "Prescription" &&
        permissionData.prescription === "Y"
      ) {
        setSelectedOption(option);
      } else if (option === "Vitals" && permissionData.vitals === "Y") {
        setSelectedOption(option);
      } else if (option === "Reports" && permissionData.reports === "Y") {
        setSelectedOption(option);
      }
    }
  };

  //Medical History End

  //queue start
  const QueuehandleClick = () => {
    setIsVerticalOpen(true);
  };
  const closeCircle = () => {
    setIsVerticalOpen(false);
  };

  const showDrawer = () => {
    setIsDrawerOpen(true);
  };
  const onClose = () => {
    setIsDrawerOpen(false);
  };
  //queue End

  const calculateAge = (dobData) => {
    const dobYear = dobData?.split("/")[2];
    const currYear = new Date().getFullYear();
    if (dobYear) {
      const patientAge = currYear - Number(dobYear);
      return patientAge;
    }
  };

  //referral
  const handleReferModal = () => {
    setReferModal(!referModal);
  };

  const sendRequest = async () => {
    setBtnDisable(true);
    let payload = {
      appointmentId: appointmentDetails?.appointmentId,
    };
    try {
      let result = await ConsentService.GetPatientConsent(payload);
      message.success("Request is Send to the patient side");
      // setMedicalOpen(false);
    } catch (error) {
      message.error("An error occured try again...");
    } finally {
      setBtnDisable(false);
    }
  };

  return (
    <Layouts>
      <VoiceCommandController />
      {loading && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="spinner"></div>
        </div>
      )}
      <div className="relative">
        <div className="flex gap-3 bg-[#FFFFFF] justify-around">
          <div className="p-1 bg-white rounded shadow-2xl border-[1px] w-full md:w-[450px] lg:w-[500px] xl:w-[550px] 4xl:w-[700px]">
            {appointmentDetails.status == 2 ||
            (appointmentDetails.serviceCode !== "APPT_VIDEO" &&
              appointmentDetails.serviceCode !== "APPT_AUDIO") ? (
              <div
                className={`h-full sticky mb-2 flex justify-center items-center`}
              >
                <FaVideoSlash className={`md:w-36 md:h-48 text-[#DEF3F2] `} />
              </div>
            ) : (
              <>
                <div className="flex justify-between items-center">
                  <div className="">
                    <Tooltip title="Open in full screen">
                      <FaArrowUpRightFromSquare
                        onClick={handleFullScreen}
                        className="text-[#1da1ab] cursor-pointer w-3 h-3"
                      />
                    </Tooltip>
                  </div>
                  <div
                    className="flex items-center w-full justify-end cursor-pointer"
                    onClick={showShareModal}
                  >
                    <Tooltip title="Share meeting link">
                      <img src={Share} alt="Share" />
                    </Tooltip>
                  </div>
                </div>
                <NewVideoConsult
                  selectedPatient={appointmentDetails}
                  fetchUrl={fetchUrl}
                  videoUrlExt={videoUrlExt}
                />
              </>
            )}
          </div>
          <div
            className={`rounded shadow-2xl bg-[#DEF3F2] w-full max-md:w-full transition-all duration-300 ease-in-out ${
              activeTab === "vital"
                ? "md:w-[400px] lg:w-[450px] xl:w-[500px]"
                : "md:w-[250px] lg:w-[280px] xl:w-[300px]"
            }`}
          >
            <div className="flex flex-col gap-3 items-center p-4">
              <div className="flex justify-center items-center bg-white h-[60px] rounded-full w-[60px]">
                {patientDetails?.photoName ? (
                  <img
                    src={
                      process.env.REACT_APP_IMAGE_URL +
                      patientDetails?.photoName
                    }
                    alt="Profile"
                    className="w-12 h-14 rounded-full object-cover"
                  />
                ) : (
                  <FaCircleUser className="w-12 h-14 rounded-full object-cover text-[#189FAA]" />
                )}
              </div>
              <h2 className="text-xs font-bold font-sans text-center text-[#333333] ">
                {patientDetails?.firstName || patientDetails?.lastName
                  ? patientDetails?.firstName + " " + patientDetails?.lastName
                  : "..."}
              </h2>
              {patientDetails?.email && (
                <div className="flex gap-1.5 items-center">
                  <img src={Mail} alt="" />
                  <span className="text-xs font-medium font-sans text-center text-[#333333]">
                    {patientDetails?.email ? patientDetails?.email : ""}
                  </span>
                </div>
              )}
              <div className="flex gap-5 items-center justify-center w-full">
                <div className="flex gap-1.5 items-center">
                  <img src={Badge} alt="" />
                  <span className="text-xs font-medium font-sans text-center text-[#333333]">
                    {patientDetails?.patientId
                      ? patientDetails?.patientId
                      : "..."}
                  </span>
                </div>
                <div className="w-px bg-slate-300 h-[19px]" />
                <img src={Age} alt="" />

                {patientDetails?.ageDob ? (
                  <span className="text-xs font-medium font-sans text-center text-[#333333]">
                    {calculateAge(patientDetails?.ageDob)}
                  </span>
                ) : (
                  <input
                    onChange={(e) => handleChange(e, "age")}
                    maxLength={3}
                    autoComplete="off"
                    type="text"
                    placeholder="----"
                    className="w-8 outline-none text-xs text-zinc-800 bg-[#DEF3F2] rounded-md p-1"
                  />
                )}
                <div className="w-px bg-slate-300 h-[19px]" />
                <div className="flex gap-1.5 items-center">
                  <img src={Gender} alt="" />

                  {patientDetails?.gender ? (
                    <span className="text-xs font-medium font-sans text-center text-[#333333]">
                      {patientDetails?.gender
                        ? patientDetails?.gender === "M"
                          ? "Male"
                          : "Female"
                        : "NA"}
                    </span>
                  ) : (
                    <Select
                      className="w-24 h-6 mr-1"
                      placeholder="Gender"
                      onChange={handleGender}
                    >
                      <option value="M">Male</option>
                      <option value="F">Female</option>
                    </Select>
                  )}
                </div>
              </div>
            </div>
            <hr className="border-[1px] border-[#D0E2E1]" />
            <div className="border-slate-300 p-4 lg:mt-2 lg:p-2 md:mx-0 lg:mx-5">
              <div className="flex gap-14 max-md:flex-wrap justify-center items-center">
                <div className="flex flex-col gap-3">
                  {patientDetails?.dob && (
                    <div className="flex gap-1.5 items-center">
                      <img src={Cake} alt="" />
                      <span className="text-xs font-medium font-sans text-center text-[#333333]">
                        {patientDetails?.dob ? patientDetails?.dob : ""}
                      </span>
                    </div>
                  )}

                  <div className="flex gap-1.5 items-center">
                    <img src={Call} alt="" />
                    <span className="text-xs font-medium font-sans text-center text-[#333333]">
                      {patientDetails?.mobile ? patientDetails?.mobile : ""}
                    </span>
                  </div>
                  {patientDetails?.city && (
                    <div className="flex gap-1.5 items-center">
                      <img src={Location} alt="" />
                      <span className="text-xs font-medium font-sans text-center text-[#333333]">
                        {patientDetails?.city ? patientDetails?.city : ""}
                      </span>
                    </div>
                  )}
                </div>
                <div className="w-px bg-slate-300 h-[85px]" />
                <div className="flex flex-col gap-3">
                  <div className="flex p-1  justify-center items-center">
                    <div className="flex gap-1 items-center">
                      <img
                        src={Height}
                        alt="Height"
                        className="w-[18px] h-[23px]"
                      />
                      <span className="text-xs text-[#333333] font-sans font-[600]">
                        Ht:
                      </span>
                    </div>
                    <div className="flex items-center">
                      <input
                        type="text"
                        placeholder="------"
                        className="w-10 outline-none text-xs text-zinc-800 bg-[#DEF3F2] rounded-md p-1"
                        value={height}
                        onChange={(e) => {
                          setHeight(e.target.value);
                          (hasConsultationId
                            ? handleVitalsUpdate
                            : handleVitals)(e, "Cm", "HI", "Height", 7);
                          setVitals((prev) => ({
                            ...prev,
                            height: e.target.value,
                          }));
                        }}
                        maxLength={5}
                        onKeyDown={handleKeyPress}
                      />
                      <span className="text-[10px] font-sans font-medium text-[#333333]">
                        Cm
                      </span>
                    </div>
                  </div>
                  <div className="flex p-1 justify-center items-center">
                    <div className="flex gap-1 items-center">
                      <img
                        src={Weight}
                        alt="Height"
                        className="w-[18px] h-[23px]"
                      />
                      <span className="text-xs text-[#333333] font-sans font-[600]">
                        Wt:
                      </span>
                    </div>
                    <div className="flex items-center">
                      <input
                        type="text"
                        placeholder="------"
                        className="w-10 outline-none text-xs text-zinc-800 bg-[#DEF3F2] rounded-md p-1"
                        value={weight}
                        onChange={(e) => {
                          setWeight(e.target.value);
                          (hasConsultationId
                            ? handleVitalsUpdate
                            : handleVitals)(e, "Kg", "WE", "Weight", 8);
                          setVitals((prev) => ({
                            ...prev,
                            weight: e.target.value,
                          }));
                        }}
                        maxLength={5}
                        onKeyDown={handleKeyPress}
                      />
                      <span className="text-[10px] font-sans font-medium text-[#333333]">
                        Kg
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className={`rounded shadow-2xl bg-[#DEF3F2] w-full max-md:w-full transition-all duration-300 ease-in-out overflow-hidden flex flex-col ${
              activeTab === "vital"
                ? "md:w-[350px] lg:w-[400px] xl:w-[450px]"
                : "md:w-[600px] lg:w-[650px] xl:w-[700px]"
            }`}
            style={{ height: "320px" }}
          >
            <div className="flex justify-between mx-6 my-2 shrink-0">
              <span
                onClick={() => setActiveTab("vital")}
                className={`p-2 rounded-full ${
                  activeTab === "vital"
                    ? "flex justify-center w-36  items-center gap-2 text-white font-semibold bg-brand-primaryColor"
                    : "w-20 cursor-pointer"
                }`}
              >
                <img
                  src={activeTab === "vital" ? vitalsWhite : vitalsBlack}
                  alt="vitals"
                />
                {activeTab === "vital" && (
                  <span className="flex gap-1">
                    <span>Vitals</span>
                  </span>
                )}
              </span>

              <span
                onClick={() => setActiveTab("ecg")}
                className={`p-2 rounded-full  ${
                  activeTab === "ecg"
                    ? "flex justify-center w-36 items-center gap-2 text-white font-semibold bg-brand-primaryColor"
                    : "w-20 cursor-pointer"
                }`}
              >
                <img
                  src={activeTab === "ecg" ? ecgWhite : ecgBlack}
                  alt="vitals"
                />
                {activeTab === "ecg" && <span>ECG</span>}
              </span>

              <span
                onClick={() => setActiveTab("steth")}
                className={`p-2 rounded-full ${
                  activeTab === "steth"
                    ? "flex w-36 justify-center items-center gap-2 text-white font-semibold bg-brand-primaryColor"
                    : "w-20 cursor-pointer"
                }`}
              >
                <img
                  src={activeTab === "steth" ? stethWhite : stethBlack}
                  alt="vitals"
                />
                {activeTab === "steth" && <span>Stethoscope</span>}
              </span>
              {patientDetails?.smartWatchUserId && (
                <span
                  title="Activities"
                  onClick={() => setActiveTab("Activities")}
                  className={`p-2 rounded-full ${
                    activeTab === "Activities"
                      ? "flex w-36 justify-center items-center gap-2 text-white font-semibold bg-brand-primaryColor"
                      : "w-20 cursor-pointer"
                  }`}
                >
                  {activeTab === "Activities" ? (
                    <img src={activityhWhite} alt="Activities" />
                  ) : (
                    <FaPersonRunning />
                  )}
                  {activeTab === "Activities" && <span>Activities</span>}
                </span>
              )}
            </div>
            {activeTab === "vital" && (
              <>
                {" "}
                {/* <div className="flex justify-center gap-2 mx-auto items-center bg-blue-400 text-white p-1 rounded-md w-32">
                  <span>Scan</span>
                  <img
                    src={bluetooth}
                    alt="bluetooth"
                    className=" w-[18px] h-[20px]"
                  />
                </div> */}
                <div className="grid grid-cols-2  justify-center items-center mt-2 md:mx-0 lg:mx-5">
                  <div className="flex flex-col gap-2 p-4 border-r border-b justify-center items-center">
                    <div className="flex gap-1 items-center">
                      <img
                        src={Bp}
                        alt="Blood Pressure"
                        className="w-[18px] h-[23px]"
                      />
                      <span className="text-xs text-[#333333] font-sans font-[600]">
                        BP
                      </span>
                    </div>
                    <div className="flex items-center">
                      <input
                        type="text"
                        placeholder="---------"
                        className="w-8 outline-none text-xs text-zinc-800 bg-[#DEF3F2] rounded-md p-1"
                        value={sys}
                        onChange={(e) => {
                          setSys(e.target.value);
                          setVitals((prev) => ({
                            ...prev,
                            systolic: e.target.value,
                          }));
                          (hasConsultationId
                            ? handleVitalsUpdate
                            : handleVitals)(
                            e,
                            "mmHg",
                            "BPS",
                            "Blood Pressure(SYS)",
                            0,
                          );
                        }}
                        maxLength={3}
                        onKeyDown={handleKeyPress}
                      />
                      /
                      <input
                        type="text"
                        placeholder="---------"
                        className="w-8 outline-none text-xs text-zinc-800 bg-[#DEF3F2] rounded-md p-1"
                        value={dia}
                        onChange={(e) => {
                          setDia(e.target.value);
                          setVitals((prev) => ({
                            ...prev,
                            diastolic: e.target.value,
                          }));
                          (hasConsultationId
                            ? handleVitalsUpdate
                            : handleVitals)(
                            e,
                            "mmHg",
                            "BPD",
                            "Blood Pressure(DIA)",
                            1,
                          );
                        }}
                        maxLength={3}
                        onKeyDown={handleKeyPress}
                      />
                      <span className="text-[10px] font-sans font-medium text-[#333333]">
                        mmHg
                      </span>
                    </div>
                  </div>
                  <div className="flex flex-col gap-2 p-4 border-b justify-center items-center">
                    <div className="flex gap-1 items-center">
                      <img
                        src={HR}
                        alt="Heart Rate"
                        className="w-[18px] h-[23px]"
                      />
                      <span className="text-xs text-[#333333] font-sans font-[600]">
                        HR
                      </span>
                    </div>
                    <div className="flex items-center">
                      <input
                        type="text"
                        placeholder="-----"
                        className="w-8 outline-none text-xs text-zinc-800 bg-[#DEF3F2] rounded-md p-1"
                        value={heartRate}
                        onChange={(e) => {
                          setHeartRate(e.target.value);
                          (hasConsultationId
                            ? handleVitalsUpdate
                            : handleVitals)(
                            e,
                            "Beats/min",
                            "HR",
                            "Heart Rate",
                            3,
                          );
                          setVitals((prev) => ({
                            ...prev,
                            heartRate: e.target.value,
                          }));
                        }}
                        maxLength={3}
                        onKeyDown={handleKeyPress}
                      />
                      <span className="text-[10px] font-sans font-medium text-[#333333]">
                        bpm
                      </span>
                    </div>
                  </div>
                  <div className="flex flex-col gap-2 p-4 border-r border-b justify-center items-center">
                    <div className="flex gap-1 items-center">
                      <img
                        src={Temp}
                        alt="Temperature"
                        className="w-[14px] h-[30px]"
                      />
                      <span className="text-xs text-[#333333] font-sans font-[600]">
                        Temp
                      </span>
                    </div>
                    <div className="flex items-center">
                      <input
                        value={temp}
                        onChange={(e) => {
                          setTemp(e.target.value);
                          (hasConsultationId
                            ? handleVitalsUpdate
                            : handleVitals)(e, "°F", "TP", "Temperature", 5);
                          setVitals((prev) => ({
                            ...prev,
                            temperature: e.target.value,
                          }));
                        }}
                        maxLength={5}
                        onKeyDown={handleKeyPress}
                        placeholder="---------"
                        className="w-10 outline-none text-xs text-zinc-800 bg-[#DEF3F2] rounded-md p-1"
                      />
                      <span className="text-[10px] font-sans font-medium text-[#333333]">
                        °F
                      </span>
                    </div>
                  </div>
                  <div className="flex flex-col gap-2 p-4 border-b justify-center items-center">
                    <div className="flex gap-1 items-center">
                      <img
                        src={SPO2}
                        alt="SPO2"
                        className="w-[14px] h-[30px]"
                      />
                      <span className="text-xs text-[#333333] font-sans font-[600]">
                        SpO2
                      </span>
                    </div>
                    <div className="flex items-center">
                      <input
                        type="text"
                        placeholder="---------"
                        className="w-10 outline-none text-xs text-zinc-800 bg-[#DEF3F2] rounded-md p-1"
                        value={pulse}
                        onChange={(e) => {
                          setPulse(e.target.value);
                          (hasConsultationId
                            ? handleVitalsUpdate
                            : handleVitals)(e, "%", "SPO2", "Pulse Oxygen", 2);
                          setVitals((prev) => ({
                            ...prev,
                            pulse: e.target.value,
                          }));
                        }}
                        maxLength={3}
                        onKeyDown={handleKeyPress}
                      />
                      <span className="text-[10px] font-sans font-medium text-[#333333]">
                        %
                      </span>
                    </div>
                  </div>
                  <div className="flex flex-col gap-2 p-4 border-r justify-center items-center">
                    <div className="flex gap-1 items-center">
                      <img
                        src={RR}
                        alt="Respiration Rate"
                        className="w-[27px] h-[28px]"
                      />
                      <span className="text-xs text-[#333333] font-sans font-[600]">
                        RR
                      </span>
                    </div>
                    <div className="flex items-center">
                      <input
                        type="text"
                        placeholder="---------"
                        className="w-10 outline-none text-xs text-zinc-800 bg-[#DEF3F2] rounded-md p-1"
                        value={respirationRate}
                        onChange={(e) => {
                          setRespirationRate(e.target.value);
                          (hasConsultationId
                            ? handleVitalsUpdate
                            : handleVitals)(
                            e,
                            "Breaths/min",
                            "RR",
                            "Respiration Rate",
                            4,
                          );
                          setVitals((prev) => ({
                            ...prev,
                            respirationRate: e.target.value,
                          }));
                        }}
                        maxLength={3}
                        onKeyDown={handleKeyPress}
                      />
                      <span className="text-[10px] font-sans font-medium text-[#333333]">
                        rpm
                      </span>
                    </div>
                  </div>
                  <div className="flex flex-col gap-2 p-4 justify-center items-center">
                    <div className="flex gap-1 items-center">
                      <img src={BMI} alt="Bmi" className="w-[14px] h-[30px]" />
                      <span className="text-xs text-[#333333] font-sans font-[600]">
                        BMI
                      </span>
                    </div>
                    <div className="flex items-center">
                      <input
                        type="text"
                        placeholder="---------"
                        className="w-10 outline-none text-xs text-zinc-800 bg-[#DEF3F2] rounded-md p-1"
                        value={bmiValue}
                        disabled={true}
                        onChange={(e) => setBmiValue(e.target.value)}
                      />
                      <span className="text-[10px] font-sans font-medium text-[#333333]">
                        kg/m²
                      </span>
                    </div>
                  </div>
                </div>
              </>
            )}

            {activeTab === "ecg" && (
              <DigitalECG
                patientDetails={patientDetails}
                appointmentDetails={appointmentDetails}
              />
            )}
            {activeTab === "steth" && (
              <DigitalSteth
                patientDetails={patientDetails}
                appointmentDetails={appointmentDetails}
              />
            )}
            {activeTab === "Activities" && (
              <Activities patientDetails={patientDetails} />
            )}
          </div>
          <div
            className="w-[144px] border rounded-md p-5 relative"
            onClick={handleClick}
          >
            <div className="flex flex-col gap-2 items-center">
              <div className="w-[44px] h-[44px] rounded-full border bg-brand-primaryColor flex items-center justify-center">
                <img src={Records} alt="" className="w-[14px] h-[21px]" />
              </div>
              <div>
                <p className="text-xs font-sans font-medium text-center">
                  Patient <br /> Medical Records
                </p>
              </div>
              <div>
                <img src={Arrow} alt="" />
              </div>
            </div>
            <div className="absolute bottom-0 right-1">
              <img src={User} alt="" />
            </div>
          </div>
        </div>
        <div className="flex gap-3">
          <div className="w-[180px] h-[380px] rounded-md bg-white mt-3 flex flex-col gap-[14px]">
            {sidebarItems.map((item) => {
              const isActive = activeSection === item.id;
              if (
                item.id === "specialtyNotes" &&
                loggedUser.user.isSpecialityNotes !== "Y"
              ) {
                return null;
              }
              return (
                <div
                  key={item.id}
                  className={`w-[180px] h-[67px] border rounded-md cursor-pointer transition-all duration-300 ${
                    isActive
                      ? "border-[#189FAA] bg-[#DEF3F2]"
                      : "border-gray-300 bg-white"
                  }`}
                  onClick={() => setActiveSection(item.id)}
                >
                  <div className="flex flex-col justify-center items-center">
                    <div
                      className={`w-[28px] h-[28px] flex items-center justify-center rounded-full mt-2 transition-all duration-300 ${
                        isActive
                          ? "bg-brand-primaryColor text-white"
                          : "bg-[#E1E1E1]"
                      }`}
                    >
                      <img
                        src={item.icon}
                        alt={item.label}
                        className={`transition-all duration-300 ${
                          isActive ? "filter invert fill-white" : ""
                        }`}
                      />
                    </div>
                    <p
                      className={`text-sm font-sans font-medium transition-all duration-300 ${
                        isActive ? "text-[#189FAA]" : "text-[#333333]"
                      }`}
                    >
                      {item.label}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="w-full bg-white mt-3 border border-gray-300 rounded-md">
            <div className="flex justify-between mx-2 p-2">
              <div>
                <div className="flex gap-2 items-center">
                  <img src={RX} alt="RX" />
                  <span className="font-bold">
                    {activeSection === "addMedicines"
                      ? "Add Medicine"
                      : activeSection === "specialtyNotes"
                        ? "Specialty Notes"
                        : activeSection === "treatmentPlan"
                          ? "Treatment Plan"
                          : activeSection === "addLabTest"
                            ? "Add Lab Test"
                            : activeSection === "consultationNotes"
                              ? "Consultation Notes"
                              : ""}
                  </span>
                </div>
                {loginResultObject?.user?.dietChartApplicableYN === "Y" && (
                  <PatientDietPlan appointmentDetails={appointmentDetails} />
                )}
              </div>
              {appointmentDetails.status !== 2 &&
                appointmentDetails.serviceCode == "APPT_INPERSON" && (
                  <div>
                    {/* < button className="p-2 font-semibold text-white text-sm rounded-lg"
                    onClick={() => setShowRecorder(true)}>Voice Transcribe</button> */}

                    {/* {showRecorder && ( */}
                    <AudioRecorder
                      ref={audioRef}
                      appointmentDetails={appointmentDetails}
                      onClose={() => setShowRecorder(false)}
                    />
                    {/* )} */}
                  </div>
                )}
              <div className="flex gap-2">
                {loggedUser.user.isVoiceRecord == "Y" && (
                  <div
                    className="mic-wrapper"
                    title={isMicActive ? "Mic is Active" : "Mic is Inactive"}
                  >
                    <div
                      onClick={toggleMic}
                      className={`mic-button ${isListening ? "listening" : ""}`}
                    >
                      {isMicActive ? (
                        <FaMicrophone className="mic-icon" />
                      ) : (
                        <FaMicrophoneSlash className="mic-icon" />
                      )}
                    </div>
                    <p className="mic-status">
                      {isListening ? "Listening..." : "Mic Off"}
                    </p>
                  </div>
                )}
                <ViewReports appointmentDetails={appointmentDetails} />
                <ChCoAndAllDetails appointmentDetails={appointmentDetails} />
                {loggedUser.user.isRefillReminder == "Y" && (
                  <DatePicker
                    placeholder="Refill"
                    value={refillDate}
                    format={"DD/MM/YYYY"}
                    onChange={(date) => setRefillDate(date)}
                    disabledDate={(current) =>
                      current && current.isBefore(dayjs(), "day")
                    }
                    suffixIcon={<CalendarOutlined className="text-white" />}
                    className="custom-datepicker1 bg-[#787878] w-[130px] h-[28px] text-xs font-sans font-semibold text-black hover:bg-[#787878] hover:text-white"
                  />
                )}

                {loggedUser?.user.isRepeatOrder == "Y" && (
                  <RepeatOrder
                    appointmentDetails={appointmentDetails}
                    patientDetails={patientDetails}
                    calculateAge={calculateAge}
                    setIsPreviewModal={setIsPreviewModal}
                    setPreviewData={setPreviewData}
                    setDrugPrescription={setDrugPrescription}
                    setActiveSection={setActiveSection}
                  />
                )}
                <DatePicker
                  placeholder="Follow-up"
                  value={schedule}
                  format={"DD/MM/YYYY"}
                  onChange={(date) => setSchedule(date)}
                  disabledDate={(current) =>
                    current && current.isBefore(dayjs(), "day")
                  }
                  suffixIcon={<CalendarOutlined className="text-white" />}
                  className="custom-datepicker1 bg-[#787878] w-[130px] h-[28px] text-xs font-sans font-semibold text-black hover:bg-[#787878] hover:text-white"
                />
                <div className="border-l-2"></div>
                <button
                  onClick={handleReferModal}
                  id="refer"
                  className="w-[102px] h-[28px] flex items-center justify-center gap-1 rounded-md bg-brand-primaryColor text-xs font-sans font-semibold text-white"
                >
                  <img src={ReferIcon} alt="icon" className="w-4 h-4" />
                  Refer
                </button>
                <div className="border-l-2"></div>
                <button
                  onClick={() => endConsultation("preview")}
                  id="preview"
                  className="w-[102px] h-[28px] flex items-center justify-center gap-1 rounded-md bg-[#1DB94C] text-xs font-sans font-semibold text-white"
                >
                  <img src={preview} alt="icon" className="w-5 h-5" />
                  Preview
                </button>
                {appointmentDetails.shareEpresWithPharmacy === "Y" &&
                  appointmentDetails.status == 1 && (
                    <ShareMedicine
                      medicines={drugPrescription}
                      appointmentDetails={appointmentDetails}
                      medicineOrders={medicineOrders}
                      setMedicineOrders={setMedicineOrders}
                      selectedPharmacy={selectedPharmacy}
                      setSelectedPharmacy={setSelectedPharmacy}
                    />
                  )}

                {appointmentDetails.shareEpresWithDiagnostics === "Y" &&
                  appointmentDetails.status == 1 && (
                    <ShareLab
                      labs={labPrescription}
                      appointmentDetails={appointmentDetails}
                      labOrders={labOrders}
                      setLabOrders={setLabOrders}
                      selectedLab={selectedLab}
                      setSelectedLab={setSelectedLab}
                    />
                  )}
              </div>
            </div>
            <hr className="border" />

            {/* Content based on selection */}
            <div className="p-3">
              <div
                className={`${
                  activeSection === "consultationNotes" ? "block" : "hidden"
                }`}
              >
                <Notes
                  patientDiagnosisDetails={patientDiagnosisDetails}
                  setPatientDiagnosisDetails={setPatientDiagnosisDetails}
                  appointmentDetails={appointmentDetails}
                  chiefComplaints={chiefComplaints}
                  setChiefComplaints={setChiefComplaints}
                  symptomsList={symptomsList}
                  setSymptomsList={setSymptomsList}
                  symptoms={symptoms}
                  setSymptoms={setSymptoms}
                  setSymptomsCode={setSymptomsCode}
                  suggestiveData={suggestiveData}
                  setSelectedSympObj={setSelectedSympObj}
                  selectedSymObj={selectedSymObj}
                  fetchSuggestionData={fetchSuggestionData}
                />
              </div>
              <div
                className={`${
                  activeSection === "addMedicines" ? "block" : "hidden"
                }`}
              >
                <Medicine
                  appointmentDetails={appointmentDetails}
                  drugPrescription={drugPrescription}
                  setDrugPrescription={setDrugPrescription}
                  suggestiveData={suggestiveMedData}
                />
              </div>
              <div
                className={`${
                  activeSection === "addLabTest" ? "block" : "hidden"
                }`}
              >
                <LabTest
                  labPrescription={labPrescription}
                  setLabPrescription={setLabPrescription}
                  appointmentDetails={appointmentDetails}
                  suggestiveData={suggestiveData}
                />
              </div>
              <div
                className={`${
                  activeSection === "treatmentPlan" ? "block" : "hidden"
                }`}
              >
                <TreatmentPlan
                  suggestiveData={suggestiveData}
                  recommentation={recommentation}
                  setRecommentation={setRecommentation}
                />
              </div>
              {loggedUser.user.isSpecialityNotes == "Y" && (
                <div
                  className={`space-y-3 ${
                    activeSection === "specialtyNotes" ? "block" : "hidden"
                  }`}
                >
                  <SpecialityNotes
                    specialityForm={specialityForm}
                    values={values}
                    setValues={setValues}
                    appointmentDetails={appointmentDetails}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="flex justify-end gap-3 mt-2">
          {appointmentDetails.status !== 2 && (
            <button
              onClick={saveDraft}
              className="bg-[#787878] w-[72px] h-[31px] rounded-md text-white text-sm font-sans font-semibold"
            >
              Draft
            </button>
          )}
          {appointmentDetails.status === 2 &&
            appointmentDetails.consultationId && (
              <button
                onClick={() => endConsultation("update")}
                className="bg-green-600 w-[72px] h-[31px] rounded-md text-white text-sm font-sans font-semibold"
              >
                Update
              </button>
            )}
          {appointmentDetails.status === 1 &&
            !appointmentDetails.consultationId && (
              <button
                onClick={() => endConsultation("end")}
                id="endConsultation"
                className="bg-[#D8383A] w-[72px] h-[31px] rounded-md text-white text-sm font-sans font-semibold"
              >
                End
              </button>
            )}

          {appointmentDetails.status === 1 &&
            appointmentDetails.consultationId && (
              <button
                onClick={() => endConsultation("preConsult")}
                className="bg-[#D8383A] w-[72px] h-[31px] rounded-md text-white text-sm font-sans font-semibold"
              >
                End
              </button>
            )}
        </div>
      </div>
      <Modal
        width={"70%"}
        open={isPreviewModalOpen}
        onCancel={() => {
          setIsPreviewModal(false);
          setPreviewData(null);
        }}
        footer={[]}
      >
        {previewData && patientDetails ? (
          <PrescriptionDetails
            prescription={previewData}
            selectedPatient={patientDetails}
            editedPatientDetails={editedPatientDetails}
          />
        ) : (
          <div className="flex items-center justify-center mt-[10%]">
            <Flex align="center" gap="middle">
              <Spin size="large" tip="Loading" />
            </Flex>
          </div>
        )}
      </Modal>
      <Modal
        title={
          <div className="text-2xl flex gap-2  items-center">
            <span>Share</span>
          </div>
        }
        open={shareModal}
        onCancel={() => {
          setSendValue("");
          setShareModal(false);
        }}
        footer={[]}
        height="15%"
      >
        <div className="flex gap-1">
          <Input
            value={sendValue}
            placeholder="Enter Email ID or Mobile Number"
            className="h-10"
            onChange={(e) => setSendValue(e.target.value)}
          />

          <button
            onClick={handleShareLink}
            htmlType="submit"
            className="h-10  text-white font-semibold p-2 rounded-md disabled:cursor-not-allowed"
          >
            Send
          </button>
        </div>
      </Modal>
      <Modal
        width={"90%"}
        destroyOnClose={true}
        title={
          <div className="text-2xl flex gap-2  items-center">
            <span>Medical Records</span>
          </div>
        }
        open={medicalOpen}
        onCancel={handleMedicalCancel}
        footer={null}
      >
        {isLoading ? (
          <div className="flex items-center justify-center  h-screen">
            <Flex align="center" gap="middle">
              <Spin size="large" tip="Loading" />
            </Flex>
          </div>
        ) : (
          <div className=" h-screen px-5 pt-5">
            <div
              className="flex justify-center items-center"
              style={{ marginTop: "-2rem" }}
            >
              <div className="w-7/12">
                <Segmented
                  className="appSegment"
                  onChange={handleOptionChange}
                  value={selectedOption}
                  block
                  options={[
                    {
                      label: (
                        <Tooltip
                          placement="top"
                          title={
                            !permissionData ||
                            permissionData.medicalHistory === "N"
                              ? "Patient should provide permission to access medical history records."
                              : "Medical History"
                          }
                        >
                          <div className="bg-[inherit] w-[inherit] h-[inherit] flex gap-2 disabled:cursor-not-allowed">
                            <img
                              src={medicalHistoryIcon}
                              alt="Medical history"
                              className="w-5 h-5 mt-1 text-white"
                            />
                            Medical history
                          </div>
                        </Tooltip>
                      ),
                      value: "Medical history",
                      disabled:
                        !permissionData ||
                        permissionData.medicalHistory === "N",
                    },
                    {
                      label: (
                        <Tooltip
                          placement="top"
                          title={
                            !permissionData ||
                            permissionData.prescription === "N"
                              ? "Patient should provide permission to access prescription records."
                              : "Prescription"
                          }
                        >
                          <div className="bg-[inherit] w-[inherit] h-[inherit] flex gap-2 disabled:cursor-not-allowed">
                            <img
                              src={medicalPrescriptionIcon}
                              alt="Prescription"
                              className="w-5 h-5 mt-1 text-white"
                            />
                            Prescription
                          </div>
                        </Tooltip>
                      ),
                      value: "Prescription",
                      disabled:
                        !permissionData || permissionData.prescription === "N",
                    },
                    {
                      label: (
                        <Tooltip
                          placement="top"
                          title={
                            !permissionData || permissionData.vitals === "N"
                              ? "Patient should provide permission to access vitals records."
                              : "Vitals"
                          }
                        >
                          <div className="bg-[inherit] w-[inherit] h-[inherit] flex gap-2 disabled:cursor-not-allowed">
                            <img
                              src={medicalVitalsIcon}
                              alt="Vitals"
                              className="w-5 h-5 mt-1 text-white"
                            />
                            Vitals
                          </div>
                        </Tooltip>
                      ),
                      value: "Vitals",
                      disabled:
                        !permissionData || permissionData.vitals === "N",
                    },
                    {
                      label: (
                        <Tooltip
                          placement="top"
                          title={
                            !permissionData || permissionData.reports === "N"
                              ? "Patient should provide permission to access reports records."
                              : "Reports"
                          }
                        >
                          <div className="bg-[inherit] w-[inherit] h-[inherit] flex gap-2 disabled:cursor-not-allowed">
                            <img
                              src={medicalReportsIcon}
                              alt="Reports"
                              className="w-5 h-5 mt-1 text-white"
                            />
                            Reports
                          </div>
                        </Tooltip>
                      ),
                      value: "Reports",
                      disabled:
                        !permissionData || permissionData.reports === "N",
                    },
                  ]}
                />
              </div>
            </div>
            {(!permissionData || permissionData.length === 0) && !isLoading ? (
              <div className="w-full flex h-screen justify-center items-center">
                {isLoading ? (
                  <div className="flex items-center justify-center mt-[10%]">
                    <Flex align="center" gap="middle">
                      <Spin size="large" tip="Loading" />
                    </Flex>
                  </div>
                ) : (
                  <div>
                    {(!permissionData || permissionData.length === 0) && (
                      <>
                        <div className="flex gap-2 mx-2 justify-between items-center">
                          <div>
                            This patient didn't give consent to view Medical
                            Records , to get Consent from patient sent request
                          </div>

                          <button
                            onClick={sendRequest}
                            className="p-1 rounded-md bg-brand-primaryColor text-white font-semibold w-28"
                            disabled={btnDisable}
                          >
                            Send Request
                          </button>
                        </div>
                        <div className="w-51 h-31">
                          <img
                            src={NoDataFound}
                            alt="No Data"
                            className="w-51 h-31"
                          />
                        </div>
                        <p className="text-center ">
                          Patient should provide permission to access medical
                          records
                        </p>
                      </>
                    )}
                  </div>
                )}
              </div>
            ) : permissionData?.vitals === "N" &&
              permissionData?.reports === "N" &&
              permissionData?.medicalHistory === "N" &&
              permissionData?.prescription === "N" ? (
              <div className="flex-flex-col gap-2 mt-10">
                <div className="flex gap-2 mx-2 justify-center mt-4 items-center">
                  <div>
                    This patient didn't give consent to view Medical Records ,
                    to get Consent from patient sent request
                  </div>
                  <button
                    onClick={sendRequest}
                    className="p-1 rounded-md bg-brand-primaryColor text-white font-semibold w-28"
                    disabled={btnDisable}
                  >
                    Send Request
                  </button>
                </div>
                <div className="w-full flex flex-col items-center mt-4">
                  <img src={NoDataFound} alt="No Data" className="w-51 h-31" />
                  <p className="text-center ">
                    Patient should provide permission to access medical records
                  </p>
                </div>
              </div>
            ) : (
              <div
                className="relative p-1 h-full"
                style={{
                  maxHeight: "70vh",
                  overflowY: "auto",
                  marginTop: "1rem",
                }}
              >
                {selectedOption === "Medical history" && (
                  <MedicalHistory
                    permissionData={permissionData}
                    selectedPatient={patientDetails}
                  />
                )}

                {selectedOption === "Prescription" && (
                  <MyPresctription
                    permissionData={permissionData}
                    selectedPatient={patientDetails}
                  />
                )}

                {selectedOption === "Vitals" && (
                  <MyVitals
                    permissionData={permissionData}
                    selectedPatient={patientDetails}
                  />
                )}
                {selectedOption === "Reports" && (
                  <Reports
                    permissionData={permissionData}
                    selectedPatient={patientDetails}
                  />
                )}
              </div>
            )}
          </div>
        )}
      </Modal>
      <Modal
        title="Refer Patient"
        open={referModal}
        destroyOnClose
        onCancel={handleReferModal}
        footer={[]}
      >
        <Referal
          selectedPatient={patientDetails}
          handleCancel={handleReferModal}
        />
      </Modal>

      {isVerticalOpen ? (
        <Draggable>
          <div className="draggable-container fixed top-1/2 right-2 w-14 transform -translate-y-1/2 z-50">
            <div
              className="hidden md:block relative mb-5 cursor-pointer"
              onClick={closeCircle}
            >
              <IoIosCloseCircle className="hidden md:block text-red-400 absolute mb-1 right-0 top-0" />
            </div>
            <img
              src={patientqueue}
              alt="patientqueue"
              className=" cursor-pointer"
              title="Patient Queue"
              onClick={showDrawer}
              onTouchEnd={showDrawer}
            />
          </div>
        </Draggable>
      ) : (
        <div
          className="vertical"
          style={{ marginTop: "16rem" }}
          onClick={QueuehandleClick}
        >
          <p className="vertical-p">
            <div className="vertical-icon-dashboard">
              <MdKeyboardDoubleArrowUp />
            </div>
            Queue
          </p>
        </div>
      )}
      {isDrawerOpen && <PatientQueue onClose={onClose} />}

      <Modal
        open={videoUrlExtView}
        footer={null}
        destroyOnClose
        onCancel={() => {
          setUrlExtView(false);
          setUrlExt(null);
        }}
        closable={false}
        centered
        width="80vw"
        bodyStyle={{
          height: "80vh",
          padding: 0,
          position: "relative",
        }}
      >
        {/* Close Button */}
        <button
          onClick={() => {
            setUrlExtView(false);
            setUrlExt(null);
          }}
          style={{
            position: "absolute",
            top: 10,
            right: 10,
            zIndex: 10,
            background: "rgba(0,0,0,0.6)",
            color: "#fff",
            border: "none",
            borderRadius: "50%",
            width: 32,
            height: 32,
            cursor: "pointer",
          }}
        >
          ✕
        </button>

        <div className="w-full h-full">
          {videoUrlExt ? (
            <div
              className="w-full h-full"
              dangerouslySetInnerHTML={{
                __html: `<iframe
          id="ccc"
          scrolling="no"
          style="width:100%; height:100%; border:none;"
          src="${videoUrlExt}"
          allow="camera; microphone"
          allowfullscreen
        ></iframe>`,
              }}
            />
          ) : null}
        </div>
      </Modal>
    </Layouts>
  );
}

export default VideoConsult;
